export default "__VITE_ASSET__EPGHaaSJ__"